<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import ContactUs from '$lib/PageSections/Forms/ContactUs/ContactUs.svelte';
	import OurLocation from '$lib/PageSections/OurLocation/ourLocation.svelte';

	import factoryImage from './images/about-us-contact-us-bottomA.png';
	import installationImage from './images/KAREN-vintage-400x320.png';
</script>

<Section>
	<h2>We're Here To Help You!</h2>
	<p class="text-xl">Questions, comments and love notes are welcome.</p>
</Section>
<Section innerClass="!pt-0">
	<div class="grid grid-cols-1 gap-4 md:grid-cols-2">
		<Image
			class="h-auto object-contain px-2"
			src={installationImage}
			alt="woman installing indow insert for simple soundproofing in windows"
		/>
		<ContactUs buttonText="CONTACT US">
			{#snippet text()}
				<span></span>
			{/snippet}
		</ContactUs>
	</div>
</Section>
<Parallax image={factoryImage} />
<OurLocation />
<Awards />
<FeaturedArticles />
